import { render, staticRenderFns } from "./brand.vue?vue&type=template&id=28ddb760&scoped=true&"
import script from "./brand.vue?vue&type=script&lang=js&"
export * from "./brand.vue?vue&type=script&lang=js&"
import style0 from "./brand.vue?vue&type=style&index=0&id=28ddb760&prod&lang=scss&scoped=true&"
import style1 from "./brand.vue?vue&type=style&index=1&id=28ddb760&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ddb760",
  null
  
)

export default component.exports